const PredictiveSearch = () => {
  const { debounce, on, off, cssClasses } = window.themeCore.utils;
  const selectors = {
    predictiveSearch: ".js-predictive-search",
    form: ".js-predictive-search-form",
    input: ".js-predictive-search-input",
    resultContainer: ".js-predictive-search-result",
    searchType: "input[name='type']",
    resultWrapper: ".js-predictive-search-result-wrapper",
    tabsButton: ".js-predictive-search-tabs-button",
    preloader: ".js-preloader",
    results: ".js-predictive-search-results",
    footer: ".js-predictive-search-footer",
    tabsWrapper: ".js-predictive-search-tabs-wrapper",
    promoProducts: ".js-predictive-search-promo-products"
  };
  const attributes = {
    disabled: "disabled",
    ariaExpanded: "aria-expanded"
  };
  const classes = {
    visuallyHidden: "visually-hidden",
    ...cssClasses
  };
  const CONFIG = {
    rootRoute: window.Shopify.routes.root,
    resourcesLimit: 6,
    resourcesLimitScope: "each"
  };
  const state = {
    cachedResults: {},
    activeTab: null
  };
  const nodes = {};
  function cacheNodes() {
    nodes.predictiveSearch = document.querySelector(selectors.predictiveSearch);
    nodes.form = document.querySelector(selectors.form);
    nodes.tabButtons = [...document.querySelectorAll(selectors.tabsButton)];
    nodes.resultContainer = document.querySelector(selectors.resultContainer);
    nodes.promoProducts = document.querySelector(selectors.promoProducts);
    nodes.footer = document.querySelector(selectors.footer);
  }
  async function handleInput(event) {
    const input = event.target.closest(selectors.input);
    if (!input)
      return;
    const query = input.value.trim();
    if (!query.length)
      return clearResults();
    togglePreloader(true);
    if (state.cachedResults[query]) {
      updateResults(state.cachedResults[query]);
      togglePreloader(false);
      return;
    }
    const responseHTML = await fetchSearchResults(query);
    if (responseHTML) {
      state.cachedResults[query] = responseHTML;
      updateResults(responseHTML);
    }
    togglePreloader(false);
  }
  function clearResults() {
    var _a, _b, _c;
    if (!nodes.resultContainer)
      return;
    nodes.resultContainer.innerHTML = "";
    nodes.resultContainer.classList.add(classes.hidden);
    (_a = nodes.form) == null ? void 0 : _a.classList.remove(classes.active);
    (_b = nodes.promoProducts) == null ? void 0 : _b.classList.remove(classes.hidden);
    (_c = nodes.footer) == null ? void 0 : _c.classList.add(classes.hidden);
    resetTabButtons();
    off("click", nodes.predictiveSearch, setActiveTabCategory);
  }
  function togglePreloader(force) {
    const preloader = nodes.predictiveSearch.querySelector(selectors.preloader);
    if (!preloader)
      return;
    preloader.classList.toggle(classes.active, force);
  }
  function updateResults(responseHTML) {
    var _a, _b, _c, _d, _e, _f;
    if (!nodes.resultContainer)
      return;
    const results = responseHTML.querySelector(selectors.results);
    nodes.resultContainer.innerHTML = "";
    (_a = nodes.promoProducts) == null ? void 0 : _a.classList.add(classes.hidden);
    (_b = nodes.resultContainer) == null ? void 0 : _b.classList.remove(classes.hidden);
    if (!results) {
      (_c = nodes.form) == null ? void 0 : _c.classList.remove(classes.active);
      (_d = nodes.footer) == null ? void 0 : _d.classList.add(classes.hidden);
      setEmptyState();
      return;
    }
    (_e = nodes.form) == null ? void 0 : _e.classList.add(classes.active);
    (_f = nodes.footer) == null ? void 0 : _f.classList.remove(classes.hidden);
    nodes.resultContainer.innerHTML = results.innerHTML;
    const resultWrappers = [...nodes.predictiveSearch.querySelectorAll(selectors.resultWrapper)];
    updateTabsState(resultWrappers);
    on("click", nodes.predictiveSearch, (event) => setActiveTabCategory(event, resultWrappers));
  }
  function resetTabButtons() {
    nodes.tabButtons.forEach((tabButton) => {
      tabButton.classList.remove(classes.active);
      tabButton.setAttribute(attributes.disabled, true);
    });
  }
  function updateTabsState(resultWrappers) {
    let isFirstActiveSet = false;
    let currentActiveButton = nodes.tabButtons.find((tabButton) => isTargetActive(tabButton));
    let currentActiveResultWrapper = null;
    if (currentActiveButton) {
      currentActiveResultWrapper = resultWrappers.find((resultWrapper) => resultWrapper.dataset.id === currentActiveButton.dataset.id);
      if (!currentActiveResultWrapper)
        currentActiveButton = null;
    }
    nodes.tabButtons.forEach((tabButton) => {
      const matchingResult = resultWrappers.find((resultWrapper) => resultWrapper.dataset.id === tabButton.dataset.id);
      if (matchingResult) {
        tabButton.removeAttribute(attributes.disabled);
        if (!isFirstActiveSet && (!currentActiveButton || currentActiveButton === tabButton)) {
          tabButton.classList.add(classes.active);
          currentActiveResultWrapper = matchingResult;
          isFirstActiveSet = true;
        } else {
          tabButton.classList.remove(classes.active);
        }
      } else {
        tabButton.setAttribute(attributes.disabled, true);
        tabButton.classList.remove(classes.active);
      }
    });
    resultWrappers.forEach((resultWrapper) => {
      resultWrapper.classList.toggle(classes.visuallyHidden, resultWrapper !== currentActiveResultWrapper);
    });
  }
  function setActiveTabCategory(event, resultWrappers) {
    const targetTabButton = event.target.closest(selectors.tabsButton);
    if (!targetTabButton)
      return;
    const tabsWrapper = nodes.predictiveSearch.querySelector(selectors.tabsWrapper);
    const tabsOffset = tabsWrapper.offsetLeft + (parseInt(window.getComputedStyle(tabsWrapper).paddingLeft) || 0);
    const newActiveOffset = targetTabButton.offsetLeft;
    tabsWrapper.scrollTo({
      left: newActiveOffset - tabsOffset,
      behavior: "smooth"
    });
    nodes.tabButtons.forEach((button) => {
      button.classList.toggle(classes.active, button === targetTabButton);
      button.setAttribute(attributes.ariaExpanded, button !== targetTabButton);
    });
    resultWrappers.forEach((resultWrapper) => {
      resultWrapper.classList.toggle(classes.visuallyHidden, resultWrapper.dataset.id !== targetTabButton.dataset.id);
    });
  }
  function setEmptyState() {
    var _a, _b, _c;
    resetTabButtons();
    nodes.resultContainer.innerHTML = `
				<div class="h4 predictive-search__result-empty">
					${((_c = (_b = (_a = window.themeCore) == null ? void 0 : _a.objects) == null ? void 0 : _b.settings) == null ? void 0 : _c.predictive_search_no_result) || window.themeCore.translations.get("general.predictive_search.no_results")}
				</div>
			`;
  }
  async function fetchSearchResults(query) {
    var _a;
    try {
      const searchType = (_a = nodes.predictiveSearch.querySelector(selectors.searchType)) == null ? void 0 : _a.value;
      if (!searchType)
        return null;

      // Dual search strategy:
      // 1. Shopify native predictive search (fast, title/tags/body)
      // 2. Full search with predictive view (finds model codes in handles)
      const suggestUrl = `${CONFIG.rootRoute}search/suggest?q=${encodeURIComponent(query)}&resources[type]=${searchType}&resources[limit]=${CONFIG.resourcesLimit}&resources[limit_scope]=${CONFIG.resourcesLimitScope}&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode&section_id=predictive-search`;
      const fullSearchUrl = `${CONFIG.rootRoute}search?q=${encodeURIComponent(query)}&type=${searchType}&view=predictive`;

      const [suggestResponse, fullResponse] = await Promise.all([
        fetch(suggestUrl).catch(() => null),
        fetch(fullSearchUrl).catch(() => null)
      ]);

      const suggestHTML = suggestResponse && suggestResponse.ok
        ? new DOMParser().parseFromString(await suggestResponse.text(), "text/html")
        : null;
      const fullHTML = fullResponse && fullResponse.ok
        ? new DOMParser().parseFromString(await fullResponse.text(), "text/html")
        : null;

      // If both returned results, merge them
      if (suggestHTML && fullHTML) {
        return mergeSearchResults(suggestHTML, fullHTML);
      }
      // Return whichever has results
      return suggestHTML || fullHTML;
    } catch (error) {
      console.error("Error fetching search results:", error);
      return null;
    }
  }

  function mergeSearchResults(primaryDoc, secondaryDoc) {
    const primaryResults = primaryDoc.querySelector('.js-predictive-search-results');
    const secondaryResults = secondaryDoc.querySelector('.js-predictive-search-results');

    if (!primaryResults && secondaryResults) {
      // Primary had no results, use secondary
      // We need to inject the secondary results into the primary document
      const container = primaryDoc.createElement('div');
      container.className = 'js-predictive-search-results';
      container.innerHTML = secondaryResults.innerHTML;
      primaryDoc.body.appendChild(container);
      return primaryDoc;
    }

    if (!primaryResults || !secondaryResults) {
      return primaryResults ? primaryDoc : (secondaryResults ? secondaryDoc : primaryDoc);
    }

    // Both have results — merge product lists, avoiding duplicates
    const primaryProductList = primaryResults.querySelector('.predictive-search__result-row--products');
    const secondaryProductList = secondaryResults.querySelector('.predictive-search__result-row--products');

    if (primaryProductList && secondaryProductList) {
      // Collect existing product URLs to avoid duplicates
      const existingUrls = new Set();
      primaryProductList.querySelectorAll('a[href]').forEach(a => {
        const href = a.getAttribute('href');
        if (href) existingUrls.add(href.replace(/\?.*$/, '').replace(/\#.*$/, ''));
      });

      // Add new products from secondary results
      secondaryProductList.querySelectorAll('.predictive-search__result-col').forEach(item => {
        const link = item.querySelector('a[href]');
        if (link) {
          const href = link.getAttribute('href').replace(/\?.*$/, '').replace(/\#.*$/, '');
          if (!existingUrls.has(href)) {
            primaryProductList.appendChild(item.cloneNode(true));
            existingUrls.add(href);
          }
        }
      });
    } else if (!primaryProductList && secondaryProductList) {
      // Primary has no products wrapper, add the whole product section from secondary
      const wrapper = secondaryResults.querySelector('.js-predictive-search-result-wrapper[data-id="product"]');
      if (wrapper) {
        primaryResults.prepend(wrapper.cloneNode(true));
      }
    }

    return primaryDoc;
  }
  function onFormSubmit(event) {
    const targetForm = event.target.closest(selectors.form);
    if (!targetForm)
      return;
    event.preventDefault();
    const query = targetForm.querySelector(selectors.input).value.trim();
    if (!query.length)
      return;
    const activeTab = nodes.tabButtons.find((tabButton) => isTargetActive(tabButton));
    if (!activeTab)
      return;
    const url = `${CONFIG.rootRoute}search/?type=${activeTab.dataset.id}&options%5Bprefix%5D=last&q=${encodeURIComponent(query)}`;
    window.location.replace(url);
  }
  function isTargetActive(target) {
    return target.classList.contains(classes.active);
  }
  function closePopup() {
    if (!isTargetActive(nodes.predictiveSearch))
      return;
    window.themeCore.EventBus.emit("Toggle:searchToggleDrawer:close");
  }
  function init() {
    cacheNodes();
    if (!nodes.predictiveSearch)
      return;
    on("input", nodes.predictiveSearch, debounce(handleInput, 200, false));
    on("reset", nodes.predictiveSearch, clearResults);
    on("submit", nodes.predictiveSearch, onFormSubmit);
    on("change", window.matchMedia("(min-width: 1200px)"), closePopup);
  }
  return Object.freeze({ init });
};
const action = () => {
  window.themeCore.PredictiveSearch = window.themeCore.PredictiveSearch || PredictiveSearch();
  window.themeCore.utils.register(window.themeCore.PredictiveSearch, "predictive-search");
};
if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
